<template>
  <div id="login-form">
<!--    <p class="text-h5 mt-8">Login</p>-->
    
    <v-form class="my-4">
      <v-text-field
        v-model="email"
        type="email"
        variant="outlined"
        label="Email"
      ></v-text-field>

      <v-text-field 
        v-model="pass"
        type="password"
        variant="outlined"
        label="Password"
      ></v-text-field>

      <div class="text-right" id="login-button">
        <v-btn @click.prevent="submitLoginForm" color="green">
          <span class="text-white">Login</span>
        </v-btn>
      </div>

<!--      <router-link to="/signup" class="ml-8">Sign up instead</router-link>-->
    </v-form>

  </div>
</template>

<script>
import { submitLogin, refreshToken } from '@/services/UserServices';

export default {
  data() {
    return {
      email: '',
      pass: '',
      loginDataIsValid: true,
    };
  },
  computed: {},
  methods: {
    async rT() {
      await refreshToken();
    },

    async submitLoginForm() {
      const email = this.email.trim();
      const pass = this.pass.trim();

      // "validation"
      let user;
      if (email.length > 0 && pass.length >= 6) {
        try {
          user = await submitLogin(email, pass); // log in
        } catch(err) {
          console.log('*** Error in submitLoginForm() ***', err);
        }
      }

      if (user) {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
        await this.$store.dispatch('isAuthenticated', true);
        this.$router.push('/dash'); // auto-redirect to dashboard
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#login-form {
  min-width: 300px;
  max-width: 400px;
}
#login-button {
  margin-top: -8px;
}
</style>

